import { createSelector } from 'reselect'
import { selectBrokersLoaded } from './brokers'
import { selectMetaLoaded } from './meta'

export const selectAppLoaded = createSelector([selectMetaLoaded, selectBrokersLoaded], (m, b) => {
  return m && b
})
